export default __webpack_public_path__ + "static/media/jpn.5f188817.svg";